import { render, staticRenderFns } from "./ServiceShop.vue?vue&type=template&id=44c41b60&scoped=true"
import script from "./ServiceShop.vue?vue&type=script&lang=js"
export * from "./ServiceShop.vue?vue&type=script&lang=js"
import style0 from "./ServiceShop.vue?vue&type=style&index=0&id=44c41b60&prod&lang=scss&scoped=true"
import style1 from "./ServiceShop.vue?vue&type=style&index=1&id=44c41b60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c41b60",
  null
  
)

export default component.exports